/* 这里面进行axios的封装(携带Token) */
import axios from 'axios'
/* 根据需要来确定，使用formData的方式提交的数据是否需要进行序列化的操作 */
import QS from 'qs' // npm i qs --save
// 创建一个axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 公共请求前缀
  timeout: 60000, // 请求超时时间
  method: 'POST', // 请求方法(deafult值)
  transformRequest: [
    // 对当前请求的格式进行判断
    function(data, headers) {
      if (headers['Content-Type']) {
        if (headers['Content-Type'] === 'multipart/form-data') {
          return data
        } else if (headers['Content-Type'].includes('application/json')) {
          return JSON.stringify(data)
        }
      }
      // 对 data 进行任意转换处理
      return QS.stringify(data, { indices: false })
    }
  ]
})
// 请求拦截
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截
service.interceptors.response.use(
  response => {
    const { success } = response.data
    if (success) {
      return Promise.resolve(response.data)
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
